export default "__VITE_ASSET__POcbeo6Y__"